// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"955":"ed02fc9f","2261":"ed02fc9f","9306":"ed02fc9f"}[chunkId] + ".chunk.css";
};